module.exports = __webpack_public_path__ + "img/mp3download.04b7f106.png";